/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/

import axios from "@/axios.js";
import store from "@/store/store.js";

export default {

  getTraineeCompetencyDetails({ commit }, id) {
    return new Promise((resolve, reject) => {
      store.dispatch("trainee-competencies/get", id).then(res => {
        resolve(res)
      }).catch(err => {
        console.log("error getting trainee competency details", err)
        reject(err)
      })
      // commit("ADD_TO_ENDORSEMENT_INVITE_EMAIL_LIST", email);
    });
  },

  skipTrue({commit}) {
    return new Promise((resolve, reject) => {
      commit("SET_SKIP_VALUE", true)
    })
  },

  skipFalse({commit}) {
    return new Promise((resolve, reject) => {
      commit("SET_SKIP_VALUE", false)
    })
  },

  calculate({ commit }, progressObj) {
    return new Promise((resolve, reject) => {
      if(progressObj.q === 0) {
        commit("SET_RELEVANCY_VALUE", progressObj.value)
      } else if(progressObj.q === 1) {
        commit("SET_PROGRESS_VALUE", progressObj.value)
      } else if(progressObj.q === 2) {
        commit("SET_PRACTICE_VALUE", progressObj.value)
      } else if(progressObj.q === -1) {
        if(progressObj.value === 100){
          commit("SET_RELEVANCY_VALUE", progressObj.value)
          commit("SET_PROGRESS_VALUE", progressObj.value)
          commit("SET_PRACTICE_VALUE", progressObj.value)
          commit("SET_SKIP_VALUE", true)
        } else {
          commit("SET_SKIP_VALUE", false)
        }
      }
      resolve(progressObj.value)
    })
  },

  saveProgress({ commit }, pmr) {
    return new Promise((resolve, reject) => {
      store.dispatch("competency-progress/create", pmr).then(res => {
        resolve(res)
      }).catch(err => {
        console.log("error saving competency progress", err)
        reject(err)
      })
    });
  },

  fetchCompetencyProgress({ commit }, query) {
    return new Promise((resolve, reject) => {
      store.dispatch("competency-progress/find", query).then(res => {
        resolve(res)
      }).catch(err => {
        console.log("error finding competency progress", err)
        reject(err)
      })
    });
  },

  destroyAllState({commit}) {
    return new Promise((resolve, reject) => {
      commit("DESTROY_PROGRESS");
      commit("DESTROY_PRACTICE");
      commit("DESTROY_RELEVANCY");
      commit("DESTROY_SKIP");
    })
  }
};
